
jQuery(document).ready(function() {
  // Your code here
  console.log("ADA script is working!");

		jQuery('.social-media__facebook').attr("aria-label","facebook page, open in new tab");
		jQuery('.social-media__twitter').attr("aria-label","twitter page, open in new tab");
		jQuery('.social-media__instagram').attr("aria-label","Instagram page, open in new tab");
		jQuery('.social-media__pinterest').attr("aria-label","pinterest page, open in new tab");
		jQuery('.header__btn-account').attr("aria-label","My account page, opens in left slider");
    	jQuery('.product-collection__variants select').attr("aria-hidden","true");
    	jQuery('.product-page-info select').attr("aria-hidden","true");
    	jQuery('.product-page-info select').attr("aria-label","colour and size");
    	jQuery('.prorw_rating__input.prorw_rating__input--none').attr("aria-label","Product Rating");
    	jQuery('.Banner1 a').attr("aria-label","Shop All, womens sandals");
    	jQuery('.Banner2 a').attr("aria-label","SHOP SANDALS, the siena sport sandals for women");
    	jQuery('.Banner3 a').attr("aria-label","SHOP BOOTS, acadia hiking sandal for women");
    	jQuery('.Banner4 a').attr("aria-label","SHOP SAMARA, discover now the samara walking sandal for women");
    	jQuery('.Banner6 a').attr("aria-label","siena sport sandals for women");
    	jQuery('.Banner7 a').attr("aria-label","SHOP CORTONA sandals for women");
    	jQuery('.Banner8 a').attr("aria-label","Shop Now, Siena: Lightweight, Stylish & Durable Sport Sandals");
    	jQuery('.Banner9 a').attr("aria-label","Shop Now, Napali: Breathable Waterproof Hiking Sandals");
    	jQuery('.Banner10 a').attr("aria-label","Shop All Styles");
    	jQuery('.header__btn-compare').attr("aria-label","Compare option, dialog open on same page");
    	jQuery('.header__btn-compare').attr("haspopup","true");
    	jQuery('.footer__back-to-top').attr("aria-label","back to top");
    	jQuery('#s-32a4bbb7-8d48-4b98-9e1a-2457005300e1 a').attr("aria-label","Cortona: Sporty & Stylish Active Sandals for Women");
    	jQuery('#s-295f91f8-8e11-4a47-8bdc-8fa8a558d760 a').attr("aria-label","Siena: Lightweight, Stylish & Durable Sport Sandals");
    	jQuery('#s-10297c60-3c45-46cf-b478-37eaf91858f8 a').attr("aria-label","Napali: Breathable Waterproof Hiking Sandals");
    	jQuery('#shopify-section-template--19258326417657__main strong').attr("role","heading");
    	jQuery('#shopify-section-template--19258326417657__main strong').attr("aria-level","2");
    	jQuery('.jdgm-prev-badge__stars').removeAttr("tabindex");
    	jQuery('.jdgm-prev-badge__stars').removeAttr("role");
    	jQuery('.jdgm-prev-badge__stars').removeAttr("aria-label");
    	jQuery('.price.price--sale span').attr("aria-hidden","true");

    	jQuery('.shg-image-margin-container-s-b4d7e13b-3eaa-458c-a0f4-4038f76f5a2d img').attr("alt","");
    	jQuery('.shg-image-margin-container-s-6d23c3b7-7289-4344-8de5-1526fd933756 img').attr("alt","");

	    jQuery('img[src="https://i.shgcdn.com/e661326e-bf79-4f18-baf2-fc8e8ffb1a76/-/format/auto/-/preview/3000x3000/-/quality/lighter/"]').attr('alt', 'Logos of “One Tree Planted” and “Soles4Souls” displayed under the text “We proudly donate a portion of our profits to.');
      
    	jQuery('.footer__section-head.position-relative').removeAttr("tabindex");
    	jQuery('.footer__section-head.position-relative').removeAttr("role");
    	jQuery('.footer__section-head.position-relative').removeAttr("aria-expanded");


    	
    
jQuery('.Banner2 a[href="https://www.viakix.com/collections/womens-sandals"]').attr('aria-label', "Shop Sandals for women");
jQuery('.Banner2 a[href="/products/rebels-womens-trail-running-shoes"]').attr('aria-label', "Shop Runners");


 
	jQuery('.header__tape-close').attr('aria-label', "close");
	jQuery('.header__tape-close, .header__btn-menu, .popup-navigation__close').attr('role', "button");
	jQuery('.header__tape-close').attr('tabindex', "0");
	jQuery('.header__btn-menu').attr('aria-label', "Open Menu");
	jQuery('.popup-navigation__close').attr('aria-label', "Close Menu");
  	jQuery('.popup-navigation__close').attr('tabindex', "0");

 
document.querySelectorAll('.header__tape-close').forEach((closeBtn) => {
  // Click already works
  closeBtn.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault(); // prevent page scroll if Space is pressed
      closeBtn.click(); // simulate the click

    }
  });
});

  
	jQuery('input[name="NAME"]').attr('aria-label', "Name");
	jQuery('input[name="EMAIL"]').attr('aria-label', "Email");
	jQuery('textarea[name="MESSAGE"]').attr('aria-label', "MESSAGE");


  
  	jQuery('input[name="customer[first_name]"]')
  .attr('aria-label', 'First name')
  .attr('autocomplete', 'given-name');

jQuery('input[name="customer[last_name]"]')
  .attr('aria-label', 'Last name')
  .attr('autocomplete', 'family-name');

jQuery('input[name="customer[email]"]')
  .attr('aria-label', 'Email address')
  .attr('autocomplete', 'email');

jQuery('input[name="customer[password]"]')
  .attr('aria-label', 'Password')
  .attr('autocomplete', 'new-password'); // Better than 'off' for new accounts


jQuery('input[name="contact[product_url]"]').attr('aria-label', 'Product url');
jQuery('input[name="contact[product_sku]"]').attr('aria-label', 'Product sku');
jQuery('input[name="contact[name]"]').attr('aria-label', 'name');
jQuery('input[name="contact[email]"]').attr('aria-label', 'email');
jQuery('input[name="contact[phone]"]').attr('aria-label', 'phone');
jQuery('textarea[name="contact[body]"]').attr('aria-label', 'message area');
jQuery('input[name="quantity"]').attr('aria-label', 'quantity');
jQuery('label[id="prorw_pictures_label"]').attr('aria-label', 'pictures label');

jQuery('.stock-countdown__title, .shogun-heading-component h1, .footer__section-head h5, .footbar-product__title h4').attr("role","heading");
jQuery('.stock-countdown__title, .shogun-heading-component h1, .footer__section-head h5, .footbar-product__title h4').attr("aria-level","2");
jQuery('.product-collection__title h4').attr("role","heading");
jQuery('.product-collection__title h4').attr("aria-level","3");
  
jQuery('.footbar-product.w-100.js-footbar-product').attr("role","complementary");
jQuery('.footer__back-to-top').attr("role","navigation");
jQuery('.footer__back-to-top').attr("role","navigation");
jQuery('.js-product-button-remove-from-cart').attr("aria-label","remove item");
jQuery('.js-input-quantity-cart').attr("aria-label","product quantity");

jQuery('.shogun-accordion-title').attr("role","button");
jQuery('.shogun-accordion-title').attr("role","button");
jQuery('.shogun-accordion-header').attr("role","heading");
jQuery('.shogun-accordion-header').attr("aria-level","3");
jQuery('.shogun-accordion-icon.shogun-icon-plus span').attr("aria-hidden","true");

jQuery('.cvGsUA.direction-ltr.align-justify.para-style-body strong').attr("role","heading");
jQuery('.cvGsUA.direction-ltr.align-justify.para-style-body strong').attr("aria-level","3");

jQuery('#s-da2dedac-8b7c-4364-8d0f-9712a72f9668 h1').removeAttr("role");
jQuery('#s-da2dedac-8b7c-4364-8d0f-9712a72f9668 h1').removeAttr("aria-level");
jQuery('.footer__back-to-top').removeAttr("role");
jQuery('.footer__back-to-top').attr("role","button");


jQuery('.cvGsUA.direction-ltr.align-justify.para-style-body strong').attr("aria-level","3");




jQuery('.logo.h6.w-100.m-0.text-hide').contents().filter(function() {
  return this.nodeType === 3; // Text node
}).remove();
 
jQuery('.promobox--type-1-4, .promobox--clean, .promobox--type-2, .promobox--type-1, .product-collection__image, .Banner1').each(function() {
  jQuery(this).find('a').first().attr('tabindex', '-1');
});

jQuery('.carousel__title a:first').attr("tabindex","-1");
jQuery('.product-collection__image a:first').attr("tabindex","-1");


 
});


setTimeout(function() {
  jQuery('.product-collection__variants select').attr("aria-label", "colour and size");
  jQuery('.absolute-stretch.cursor-default').attr("tabindex", "-1");
  jQuery('.absolute-stretch.cursor-default').attr("aria-hidden", "true");
  jQuery('.shg-row img').attr("alt", "");
jQuery('.product-image__overlay-bottom a').attr("tabindex", "-1");
jQuery('.product-collection__image a:first').attr("tabindex","-1");
jQuery('#s-b4671028-f24a-4e92-9002-dbecdf8ef99e img').attr("alt","We proudly donate a portion of our profits to: One Tree Planted and Soles 4 Souls Wearing out poverty");
jQuery('#s-65d7f0a6-d6be-421c-9b7e-d7ce1a21015d img').attr("alt","Sizing guide for the Acadia Sandal. The text reads: SIZING TIPS. It's easy to find the right Acadia Sandal size for you. The Acadias fit true to size, so we recommend ordering your regular size. Based on thousands of pairs sold worldwide, order your regular size. If between sizes, order one size down.A table lists corresponding sizes: If you typically wear US sizes 6 or 6.5, order Sandal Size 6. For 7 or 7.5, order Size 7. For 8 or 8.5, order Size 8. For 9 or 9.5, order Size 9.For 10 or 10.5, order Size 10. For 11 or 11.5, order Size 11. The sandals fit the following foot widths: Narrow (AA), Medium (B/M), Wide (C/D), and Extra-Wide. Additional text advises: 'If unsure about sizing, contact our customer care team for assistance. Free and easy returns are available if the sandals don’t fit.'");
jQuery('#s-0cbbd875-0b17-4b51-8bfd-ba109cd68404 img').attr("alt","Viakix Sandals sizing guide with recommendations for selecting the correct size. The text states: 'SIZING TIPS. It’s easy to find the right Viakix Sandal size. All Viakix sandals fit true to size, so we recommend ordering your regular size. Based on global sales data, choose your regular size. If you are between sizes, order one size down. A sizing chart compares typical US shoe sizes to Viakix Sandal sizes:US Sizes 6 or 6.5 → Order Sandal Size 6, US Sizes 7 or 7.5 → Order Sandal Size 7, US Sizes 8 or 8.5 → Order Sandal Size 8, US Sizes 9 or 9.5 → Order Sandal Size 9, US Sizes 10 or 10.5 → Order Sandal Size 10, US Sizes 11 or 11.5 → Order Sandal Size 11. The sandals accommodate these foot widths: Narrow (AA), Medium (B/M), Wide (C/D), and Extra-Wide (E).Additional text encourages customers to contact the support team for sizing help and notes that returns are free and easy if the sandals don’t fit.");

jQuery('#s-d1f29255-93a6-4c13-860c-ca032a2be954 a:first').attr("tabindex", "-1");
jQuery('#s-d1f29255-93a6-4c13-860c-ca032a2be954 a:first').attr("aria-label", "womens sandals");
jQuery('#s-d1f29255-93a6-4c13-860c-ca032a2be954 a:eq(1)').attr("aria-label", "Shop Now, womens sandals");
jQuery('#s-66b920ca-f084-48c1-92f1-a956d4a88505 a:first').attr("aria-label", "womens sandals");

jQuery('.social-share__item--facebook').attr("aria-label", "Share this blog to Facebook page, opens in new tab ");
jQuery('.social-share__item--twitter').attr("aria-label", "Share this blog to twitter page, opens in new tab ");
jQuery('.social-share__item--pinterest').attr("aria-label", "Share this blog to pinterest page, opens in new tab ");
jQuery('.social-share__item--linkedin').attr("aria-label", "Share this blog to linkedin page, opens in new tab ");
jQuery('.social-share__item--buffer').attr("aria-label", "Share this blog to buffer page, opens in new tab ");
jQuery('.social-share__item--reddit').attr("aria-label", "Share this blog to reddit page, opens in new tab ");

  
jQuery('.collection-filters__checkbox.input-checkbox.d-flex.align-items-center.mb-15.mb-lg-10.mr-15.mr-lg-10.input-checkbox--unbordered.cursor-pointer').attr("aria-label", "filter");
jQuery('a[href="https://www.viakix.com/products/the-napali-hiking-sandals-for-women"]').attr('aria-label', "The napili hiking sandals for women");
jQuery('a[href="https://www.viakix.com/products/the-siena-sport-sandals-for-women"]').attr('aria-label', "the siena sport sandals for women");
jQuery('a[href="https://www.viakix.com/products/siena-sport-sandals-for-women"]').attr('aria-label', "siena sport sandals for women");
jQuery('.mssb-rc-text').css('color', 'black !important ');
jQuery('.product-collection__title.mb-3 h4').attr("aria-level","3");
jQuery('.footer__subscription h5').attr("aria-level","2");
jQuery('.shogun-success-alert').attr("role","alert");
jQuery('input[name="contact[email]').attr('aria-label', "email");
jQuery('input[name="contact[email]').attr('id', "newsletter-email-1");

jQuery('.slider__slick.js-slider-tracking.slick-initialized.slick-slider').attr('aria-label',"");
jQuery('.carousel__slider.position-relative.js-slider-tracking').attr('aria-label',"review section");
jQuery('.carousel__slider.position-relative.js-slider-tracking').attr('role',"region");

jQuery('.jdgm-btn.jdgm-btn--solid.jdgm-paginate__load-more').attr('tabindex',"0");
//jQuery('.jdgm-rev-widg__summary-stars').removeAttr('role');



jQuery('.product-collection__wrapper.mb-30.mb-lg-30').each(function () {

    jQuery(this).find('form').attr('tabindex','-1');
    jQuery(this).find('input').attr('tabindex','-1');

    jQuery(this).find('a').first().attr('tabindex','-1');

});

jQuery('.carousel__item.col-auto.slick-slide.slick-active').attr('tabindex','-1');

    	jQuery('#s-276b6c52-e0af-493f-8a1d-9d8ad0087cf6 img').attr("alt","Adam signature");
    	jQuery('#s-22508b47-6646-469e-b21a-ea389aedea63 img').attr("alt","Elissa signature");
    	jQuery('#s-cc6d64ff-4c76-4dff-a0b5-310dbe05cc82 img').attr("alt","Black-and-white photograph of a happy family with a Elissa , Adam, and two young children sitting closely together and smiling at the camera outdoors.");
    	
      
      jQuery('.d-flex.flex-center.position-absolute.left-0.ml-10.cursor-pointer').attr("aria-label","minus");
      jQuery('.d-flex.flex-center.position-absolute.right-0.mr-10.cursor-pointer').attr("aria-label","add");





      $(document).ready(function () {
  $('.jdgm-rev-widg__summary-stars').each(function () {
    var $container = $(this);
    var $link = $container.find('a.jdgm-link');

    // Add aria-hidden to decorative stars
    $container.find('.jdgm-star').attr('aria-hidden', 'true');

    // Move the link's parent span outside the role="img" container
    var $avg = $container.find('.jdgm-rev-widg__summary-average').detach();

    // Patch new tab warning
    $link.attr({
      'aria-label': 'View all reviews, 4.75 out of 5 stars (opens in a new tab)',
      'target': '_blank'
    });
    $avg.find('a').append('<span class="sr-only"> (opens in a new tab)</span>');

    // Insert the link block immediately after the role="img" div
    $container.after($avg);
  });
});


 

  
}, 3000);


 
  jQuery(document).ready(function() {
    // Find all empty h2 elements and remove them
    jQuery('h3').each(function() {
      if (!jQuery(this).text().trim()) {
        jQuery(this).remove();
      }
    });
  });


jQuery('.d-none.d-lg-block.mb-10').each(function () {
  var href = jQuery(this).attr('href');

  if (href && href.includes('/products/')) {
    // Extract the product slug from the URL
    var productSlug = href.split('/products/')[1];

    // Clean the slug: remove filler words like 'the', 'a', 'an'
    var cleaned = productSlug
      .replace(/-/g, ' ')                        // replace hyphens with spaces
      .replace(/\b(the|a|an)\b/gi, '')           // remove filler words
      .replace(/\s+/g, ' ')                      // collapse multiple spaces
      .trim();

    // Capitalize the first letter of each word
    var ariaLabel = cleaned.replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });

    // Add aria-label to the <a> tag
    jQuery(this).attr('aria-label', ariaLabel);
  }
});

jQuery('.d-none.d-lg-block.mb-10').each(function () {
  var href = jQuery(this).attr('href');

  if (href && href.includes('https://www.viakix.com/products/')) {
    // Extract product slug from the full URL
    var productSlug = href.split('https://www.viakix.com/products/')[1];

    // Clean and format it for ARIA label
    var ariaLabel = productSlug
      .replace(/-/g, ' ')                      // Replace hyphens with spaces
      .replace(/\b(the|a|an)\b/gi, '')         // Remove filler words
      .replace(/\s+/g, ' ')                    // Remove extra spaces
      .trim()                                  // Trim start/end
      .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize each word

    // Set the aria-label on the <a> tag
    jQuery(this).attr('aria-label', ariaLabel);
  }
});

jQuery('.d-none.d-lg-block.mb-10').each(function () {
  var href = jQuery(this).attr('href');

  if (href && href.includes('https://www.viakix.com/collections/')) {
    // Extract product slug from the full URL
    var productSlug = href.split('https://www.viakix.com/collections/')[1];

    // Clean and format it for ARIA label
    var ariaLabel = productSlug
      .replace(/-/g, ' ')                      // Replace hyphens with spaces
      .replace(/\b(the|a|an)\b/gi, '')         // Remove filler words
      .replace(/\s+/g, ' ')                    // Remove extra spaces
      .trim()                                  // Trim start/end
      .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize each word

    // Set the aria-label on the <a> tag
    jQuery(this).attr('aria-label', ariaLabel);
  }
});


jQuery('.d-block').each(function () {
  var href = jQuery(this).attr('href');

  if (href && href.includes('/products/')) {
    // Extract the product slug from the URL
    var productSlug = href.split('/products/')[1];

    // Clean the slug: remove filler words like 'the', 'a', 'an'
    var cleaned = productSlug
      .replace(/-/g, ' ')                        // replace hyphens with spaces
      .replace(/\b(the|a|an)\b/gi, '')           // remove filler words
      .replace(/\s+/g, ' ')                      // collapse multiple spaces
      .trim();

    // Capitalize the first letter of each word
    var ariaLabel = cleaned.replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });

    // Add aria-label to the <a> tag
    jQuery(this).attr('aria-label', ariaLabel);
  }
});



document.querySelectorAll('.product-collection__wrapper').forEach(wrapper => {
  const title = wrapper.querySelector('.product-collection__title')?.textContent.trim();
  
  if (title) {
    wrapper.querySelectorAll('.d-block').forEach(block => {
      block.setAttribute('aria-label', title);
    });
  }
});


setTimeout(function () {
  jQuery('.absolute-stretch.cursor-default').each(function () {
    var href = jQuery(this).attr('href');

    if (href && href.includes('/products/')) {
      // Extract the product slug from the URL
      var productSlug = href.split('/products/')[1];

      // Clean the slug: remove filler words like 'the', 'a', 'an'
      var cleaned = productSlug
        .replace(/-/g, ' ')                        // replace hyphens with spaces
        .replace(/\b(the|a|an)\b/gi, '')           // remove filler words
        .replace(/\s+/g, ' ')                      // collapse multiple spaces
        .trim();

      // Capitalize the first letter of each word
      var ariaLabel = cleaned.replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });

      // Add aria-label to the <a> tag
      jQuery(this).attr('aria-label', ariaLabel);
    }
  });
}, 3000); // 3000 milliseconds = 3 seconds


setTimeout(function () {
  jQuery('.absolute-stretch.cursor-default').each(function () {
    var href = jQuery(this).attr('href');

    if (href && href.includes('/collections/womens-sandals/products/')) {
      // Extract the product slug from the URL
      var productSlug = href.split('/collections/womens-sandals/products/')[1];

      // Clean the slug: remove filler words like 'the', 'a', 'an'
      var cleaned = productSlug
        .replace(/-/g, ' ')                        // replace hyphens with spaces
        .replace(/\b(the|a|an)\b/gi, '')           // remove filler words
        .replace(/\s+/g, ' ')                      // collapse multiple spaces
        .trim();

      // Capitalize the first letter of each word
      var ariaLabel = cleaned.replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });

      // Add aria-label to the <a> tag
      jQuery(this).attr('aria-label', ariaLabel);
    }
  });
}, 3000); // 3000 milliseconds = 3 seconds


//=========================

function forceTabindexNegativeOne() {
  const links = document.querySelectorAll('.absolute-stretch.cursor-default[tabindex="0"]');
  links.forEach((link) => link.setAttribute('tabindex', '-1'));
}

// Check every 500ms (adjust as needed)
setInterval(forceTabindexNegativeOne, 500);

//========================

$('#shopify-section-template--19258325303545__main a').each(function () {
    var href = $(this).attr('href');
    
    // Make sure it's a blog URL
    if (href && href.includes('/blogs/news/')) {
        // Extract the blog title from URL
        var slug = href.split('/').pop(); // Gets the last part of the URL
        var title = decodeURIComponent(slug.replace(/-/g, ' '));
        
        // Capitalize first letter
        title = title.charAt(0).toUpperCase() + title.slice(1);

        // Set aria-label
        $(this).attr('aria-label', 'Learn more about ' + title);
    }
});

//========================

$(document).ready(function () {
  $('.price--sale').each(function () {
    const $priceWrapper = $(this);
    const $originalPrice = $priceWrapper.find('span').eq(0);
    const $salePrice = $priceWrapper.find('span').eq(1);

    const originalPriceText = $originalPrice.text().trim();
    const salePriceText = $salePrice.text().trim();

    // Build and set the aria-label
    const ariaLabel = `Original price ${originalPriceText}, now ${salePriceText}`;
    $priceWrapper.attr('aria-label', ariaLabel);
  });
});


//=======Sortsite errors=================

jQuery('.footer__section-head').attr('role', 'button');
jQuery('.footer__back-to-top').attr('aria-label', 'back to top');




//======= Website monitoring 7th March 2026 =================

//======= Dropdown icons  =================


// ── Helpers (defined in outer scope) ──────────────────────
function openSubmenu($btn, $submenu) {
  $btn.attr('aria-expanded', 'true');
  $submenu.css('display', 'block');
  $submenu.find('a').first().focus();
}

function closeSubmenu($btn, $submenu) {
  $btn.attr('aria-expanded', 'false');
  $submenu.css('display', ''); // reset to let CSS take over when closed
}

// ── All handlers inside document ready ────────────────────
$(function () {

  // Helper to find submenu relative to button (no ID needed)
  function getSubmenu($btn) {
    return $btn.closest('.menu__item--has-children').find('.menu__level-03').first();
  }

  // Click
  $(document).on('click', '.submenu-toggle--inline', function () {
    const $btn     = $(this);
    const $submenu = getSubmenu($btn);
    const isOpen   = $btn.attr('aria-expanded') === 'true';

    // Debug
    console.log('Button clicked, submenu found:', $submenu.length, 'isOpen:', isOpen);

    isOpen ? closeSubmenu($btn, $submenu) : openSubmenu($btn, $submenu);
  });

  // Keyboard on toggle button (Enter / Space / Escape)
  $(document).on('keydown', '.submenu-toggle--inline', function (e) {

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const $btn     = $(this);
      const $submenu = getSubmenu($btn);
      const isOpen   = $btn.attr('aria-expanded') === 'true';
      isOpen ? closeSubmenu($btn, $submenu) : openSubmenu($btn, $submenu);
    }

    if (e.key === 'Escape') {
      const $btn     = $(this);
      const $submenu = getSubmenu($btn);
      closeSubmenu($btn, $submenu);
      $btn.focus();
    }
  });

  // Arrow keys inside submenu
  $(document).on('keydown', '.menu__level-03 a', function (e) {
    const $links = $(this).closest('.menu__level-03').find('a');
    const index  = $links.index(this);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      $links.eq(index + 1).focus();
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (index === 0) {
        $(this).closest('.menu__item--has-children')
               .find('.submenu-toggle--inline')
               .focus();
      } else {
        $links.eq(index - 1).focus();
      }
    }

    if (e.key === 'Escape') {
      const $btn     = $(this).closest('.menu__item--has-children').find('.submenu-toggle--inline');
      const $submenu = $(this).closest('.menu__level-03');
      closeSubmenu($btn, $submenu);
      $btn.focus();
    }
  });

  // Auto-close when focus leaves
  $(document).on('focusout', '.menu__item--has-children', function () {
    const $item = $(this);
    setTimeout(function () {
      if (!$item.find(':focus').length) {
        const $btn     = $item.find('.submenu-toggle--inline');
        const $submenu = getSubmenu($btn);
        closeSubmenu($btn, $submenu);
      }
    }, 100);
  });

});



// =============


// ── Cart slider focus management ───────────────────────
var $cartTrigger = null;
var cartCloseBtn = document.querySelector('.popup-cart__close');

if (cartCloseBtn) {
  cartCloseBtn.setAttribute('tabindex', '0');
  cartCloseBtn.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') cartCloseBtn.click();
  });
}

// Escape closes cart when focus is inside it
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    var popupCart = document.querySelector('.popup-cart');
    if (popupCart && cartCloseBtn && popupCart.contains(document.activeElement)) {
      cartCloseBtn.click();
    }
  }
});

function focusFirstInPopupCart() {
  var focusableSelectors = 'a[href], button:not(:disabled), input:not(:disabled), [tabindex]:not([tabindex="-1"])';
  var $cart = jQuery('.popup-cart');

  $cart.attr({
    'role':       'dialog',
    'aria-modal': 'true',
    'aria-label': 'Shopping cart'
  });

  var $firstFocusable = $cart.find(focusableSelectors).filter(':visible').first();
  if ($firstFocusable.length) {
    $firstFocusable.focus();
  }
}

// ✅ Bind ONLY cart-specific triggers — exclude js-popup-button to avoid conflict
jQuery('.header__btn-cart, .js-product-button-add-to-cart, .footbar-product__button-add-to-cart button')
  .on('click', function () {
    $cartTrigger = jQuery(this); // store exactly which element opened the cart
    setTimeout(focusFirstInPopupCart, 500);
  });

// ✅ Return focus to stored trigger on close
jQuery(document).on('click', '.popup-cart__close', function () {
  if ($cartTrigger) {
    var $target = $cartTrigger; // capture before nulling
    $cartTrigger = null;
    setTimeout(function () {
      $target.focus();
    }, 100);
  }
});

// ✅ Also return focus when closed via Escape
jQuery(document).on('keydown', function (e) {
  if (e.key === 'Escape') {
    var $cart = jQuery('.popup-cart');
    if ($cart.is(':visible') && $cartTrigger) {
      var $target = $cartTrigger;
      $cartTrigger = null;
      setTimeout(function () {
        $target.focus();
      }, 100);
    }
  }
});

// ── Contact popup (js-popup-button) — kept separate ───
var popupButton     = jQuery('.js-popup-button').not('.header__btn-cart'); // ✅ exclude cart button
var closeButton     = jQuery('.popup-product-contact__close');
var addToCartButton = jQuery('.product-page-info__button-add-to-cart .js-product-button-add-to-cart');

popupButton.attr('tabindex', '0');
closeButton.attr('tabindex', '0');
closeButton.attr('aria-label', 'Close');

popupButton.on('keydown', function (e) {
  if (e.key === 'Enter') jQuery(this).trigger('click');
});

closeButton.on('keydown', function (e) {
  if (e.key === 'Enter') jQuery(this).trigger('click');
});

popupButton.on('click', function () {
  setTimeout(function () {
    closeButton.focus();
  }, 500);
});

closeButton.on('click', function () {
  addToCartButton.focus();
});


// ✅ Return focus on close button click AND Escape
function returnFocusToCartTrigger() {
  if ($cartTrigger) {
    var $target = $cartTrigger;
    $cartTrigger = null;
    setTimeout(function () {
      $target.focus();
    }, 150); // slightly longer delay to wait for cart to finish closing animation
  }
}

// Close button click
jQuery(document).on('click', '.popup-cart__close', function () {
  returnFocusToCartTrigger();
});

// Escape key
jQuery(document).on('keydown', function (e) {
  if (e.key === 'Escape') {
    var $cart = jQuery('.popup-cart');
    if ($cart.length && $cartTrigger) {
      returnFocusToCartTrigger();
    }
  }
});



(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('.js-popup');
    if (!popup) return;
    // Step 1: Store the triggering element when any popup button is clicked
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-js-popup-button]');
      if (btn) {
        popup._lastFocusTrigger = btn;
      }
    }, true); // capture phase ensures we run before the popup opens
    // Step 2: Return focus to the trigger when the popup closes
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var el = mutation.target;
          var wasActive = mutation.oldValue && mutation.oldValue.indexOf('active') !== -1;
          var isNowInactive = !el.classList.contains('active');
          if (wasActive && isNowInactive && el._lastFocusTrigger) {
            var trigger = el._lastFocusTrigger;
            el._lastFocusTrigger = null;
            // Small delay to let the close animation complete
            setTimeout(function () {
              trigger.focus();
            }, 50);
          }
        }
      });
    });
    observer.observe(popup, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class']
    });
  });
})();





//==========

    var intervalID = window.setInterval(myCallback, 50);
    function myCallback() {
        var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
        if (textAreaCheck.length > 0) {
            for (var i = 0; i < textAreaCheck.length; i++) {
                textAreaCheck[i].setAttribute('aria-label', 'g-recaptcha-response');
            }
            console.log(textAreaCheck);
            clearInterval(intervalID);
        }
    }



    //========== thumnail product ===================

// ── Product Gallery Thumbnails Accessibility ───────────────
jQuery(document).ready(function () {

  function initGalleryThumbnails() {
    var $thumbnails = jQuery('[data-js-product-gallery-thumbnail-item]');

    $thumbnails.each(function (index) {
      var $thumb  = jQuery(this);
      var $img    = $thumb.find('img');
      var altText = $img.attr('alt') || 'Product image';
      var group   = $thumb.attr('data-group') || '';

      // Make each thumbnail focusable and give it proper ARIA
      $thumb
        .attr('tabindex', '0')
        .attr('role', 'button')
        .attr('aria-label', 'View ' + altText + (group ? ' - ' + group : '') + ', image ' + (index + 1) + ' of ' + $thumbnails.length)
        .attr('aria-pressed', $thumb.hasClass('current') ? 'true' : 'false')
        .removeAttr('aria-hidden');
    });

    // Wrap thumbnails in a group for screen readers
    var $list = $thumbnails.first().closest('.slick-track');
    $list
      .attr('role', 'group')
      .attr('aria-label', 'Product image thumbnails');
  }

  // ── Click: select thumbnail ──────────────────────────────
  jQuery(document).on('click', '[data-js-product-gallery-thumbnail-item]', function () {
    updateActiveThumb(jQuery(this));
  });

  // ── Keyboard: Enter/Space to select, Arrow keys to navigate
  jQuery(document).on('keydown', '[data-js-product-gallery-thumbnail-item]', function (e) {
    var $current    = jQuery(this);
    var $allThumbs  = jQuery('[data-js-product-gallery-thumbnail-item]').filter(':visible');
    var currentIdx  = $allThumbs.index($current);

    switch (e.key) {

      case 'Enter':
      case ' ':
        e.preventDefault();
        $current.trigger('click'); // trigger existing slick click
        updateActiveThumb($current);
        break;

      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        var $next = $allThumbs.eq(currentIdx + 1);
        if ($next.length) {
          $next.focus();
        } else {
          $allThumbs.first().focus(); // wrap to first
        }
        break;

      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        var $prev = $allThumbs.eq(currentIdx - 1);
        if ($prev.length && currentIdx > 0) {
          $prev.focus();
        } else {
          $allThumbs.last().focus(); // wrap to last
        }
        break;

      case 'Home':
        e.preventDefault();
        $allThumbs.first().focus();
        break;

      case 'End':
        e.preventDefault();
        $allThumbs.last().focus();
        break;
    }
  });

  // ── Update aria-pressed when active thumb changes ────────
  function updateActiveThumb($selected) {
    var $allThumbs = jQuery('[data-js-product-gallery-thumbnail-item]');
    $allThumbs.attr('aria-pressed', 'false');
    $selected.attr('aria-pressed', 'true');
  }

  // ── Watch for slick reinitialising (e.g. on variant change)
  var galleryObserver = new MutationObserver(function () {
    initGalleryThumbnails();
  });

  var $galleryTrack = document.querySelector('.product-gallery__thumbnail_item');
  if ($galleryTrack) {
    galleryObserver.observe($galleryTrack.parentElement, {
      childList:  true,
      subtree:    true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Initial setup
  initGalleryThumbnails();

});

    //========== Arrow for product page ===================


    // ── Product Gallery Main Arrows Accessibility ──────────────
jQuery(document).ready(function () {

  var $prevArrow = jQuery('[data-js-product-gallery-main-arrow-prev]');
  var $nextArrow = jQuery('[data-js-product-gallery-main-arrow-next]');

  // Make arrows focusable and add ARIA attributes
  $prevArrow
    .attr('tabindex', '0')
    .attr('role', 'button')
    .attr('aria-label', 'Previous image');

  $nextArrow
    .attr('tabindex', '0')
    .attr('role', 'button')
    .attr('aria-label', 'Next image');

  // ── Enter/Space to trigger click ──────────────────────────
  jQuery(document).on('keydown', '[data-js-product-gallery-main-arrow-prev], [data-js-product-gallery-main-arrow-next]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      jQuery(this).trigger('click');
    }
  });

  // ── Update aria-disabled when slick changes state ─────────
  function syncArrowState() {
    var $prev = jQuery('[data-js-product-gallery-main-arrow-prev]');
    var $next = jQuery('[data-js-product-gallery-main-arrow-next]');

    // Sync tabindex with aria-disabled
    if ($prev.attr('aria-disabled') === 'true') {
      $prev.attr('tabindex', '-1');
    } else {
      $prev.attr('tabindex', '0');
    }

    if ($next.attr('aria-disabled') === 'true') {
      $next.attr('tabindex', '-1');
    } else {
      $next.attr('tabindex', '0');
    }
  }

  // ── Announce slide change to screen readers ───────────────
  // Create a live region if it doesn't exist
  if (!jQuery('#gallery-live-region').length) {
    jQuery('body').append(
      '<div id="gallery-live-region" role="status" aria-live="polite" aria-atomic="true" class="sr-only" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;"></div>'
    );
  }

  // function announceSlide() {
  //   // var $active   = jQuery('[data-js-product-gallery-thumbnail-item].current, [data-js-product-gallery-thumbnail-item].slick-current');
  //   // var $allThumbs = jQuery('[data-js-product-gallery-thumbnail-item]');
  //   // var total     = $allThumbs.length;
  //   // var current   = $allThumbs.index($active) + 1;
  //   // var altText   = $active.find('img').attr('alt') || 'Product image';

  //   // jQuery('#gallery-live-region').text(
  //   //   'Image ' + current + ' of ' + total + ': ' + altText
  //   // );
    
  // }

function announceSlide() {
  var $activeSlide = $carousel.find('.slick-slide.slick-active:not(.slick-cloned)').first();

  // ✅ Get product name from image alt text
  var productName = $activeSlide.find('[data-js-product-image] img').attr('alt') || '';

  // ✅ Get price
  var price = $activeSlide.find('.price, [data-js-product-price]').first().text().trim();

  var announcement = productName;
  if (price) announcement += ', ' + price;

  jQuery('#carousel-live-region').text(announcement || 'Next slide');
}


  // ── Watch for slick slide changes ─────────────────────────
  jQuery(document).on('click', '[data-js-product-gallery-main-arrow-prev], [data-js-product-gallery-main-arrow-next]', function () {
    setTimeout(function () {
      syncArrowState();
      announceSlide();
    }, 300); // wait for slick animation to complete
  });

  // Also announce on thumbnail click
  jQuery(document).on('click', '[data-js-product-gallery-thumbnail-item]', function () {
    setTimeout(announceSlide, 300);
  });

  // Initial state sync
  syncArrowState();

});


 

 // ── Shogun Accordion aria-expanded only ───────────────────
jQuery(document).ready(function () {

  


  // Set initial aria-expanded based on current display state
  jQuery('.shogun-accordion').each(function () {
    var $body  = jQuery(this).find('.shogun-accordion-body');
    var $title = jQuery(this).find('.shogun-accordion-title');
    var isOpen = $body.css('display') !== 'none';
    $title.attr('aria-expanded', isOpen ? 'true' : 'false');
  });

  // Watch each body for display style changes and sync aria-expanded
  jQuery('.shogun-accordion-body').each(function () {
    var $body  = jQuery(this);
    var $title = $body.closest('.shogun-accordion').find('.shogun-accordion-title');

    new MutationObserver(function (mutations) {
      mutations.forEach(function () {
        var isOpen = $body.css('display') !== 'none';
        $title.attr('aria-expanded', isOpen ? 'true' : 'false');
      });
    }).observe(this, {
      attributes:      true,
      attributeFilter: ['style']
    });
  });

});


// ============================================ carousel__item slider product page ==================================================================


// ── Carousel Accessibility ─────────────────────────────────
jQuery(document).ready(function () {

  function initCarousel() {
    var $carousel = jQuery('[data-js-carousel]');
    if (!$carousel.length) return;

    // ✅ Correct selectors from DOM inspection
    var $prevBtn = jQuery('.carousel__prev-placeholder');
    var $nextBtn = jQuery('.carousel__next-placeholder');

    if (!$prevBtn.length || !$nextBtn.length) {
      console.warn('Carousel arrows not found');
      return;
    }

    // ── Prev / Next arrows ───────────────────────────────────
    $prevBtn
      .attr('tabindex', '0')
      .attr('role', 'button')
      .attr('aria-label', 'Previous slide');

    $nextBtn
      .attr('tabindex', '0')
      .attr('role', 'button')
      .attr('aria-label', 'Next slide');

    // ── Enter / Space on prev/next ────────────────────────────
    jQuery(document).off('keydown.carouselArrows').on('keydown.carouselArrows', '.carousel__prev-placeholder, .carousel__next-placeholder', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        jQuery(this).trigger('click');
      }
    });

    // ── Dots ──────────────────────────────────────────────────
    function initDots() {
      $carousel.find('.slick-dots')
        .attr('role', 'tablist')
        .attr('aria-label', 'Slide navigation');

      $carousel.find('.slick-dots li').each(function (i) {
        var $btn     = jQuery(this).find('button');
        var isActive = jQuery(this).hasClass('slick-active');

        $btn
          .attr('tabindex', isActive ? '0' : '-1')
          .attr('role', 'tab')
          .attr('aria-label', 'Go to slide ' + (i + 1))
          .attr('aria-selected', isActive ? 'true' : 'false');
      });
    }

    // ── Arrow keys on dots ────────────────────────────────────
    jQuery(document).off('keydown.carouselDots').on('keydown.carouselDots', '.slick-dots button', function (e) {
      var $allDots = $carousel.find('.slick-dots button');
      var idx      = $allDots.index(this);

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        jQuery(this).trigger('click');
      }

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        $allDots.eq(idx + 1 < $allDots.length ? idx + 1 : 0).focus().trigger('click');
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        $allDots.eq(idx - 1 >= 0 ? idx - 1 : $allDots.length - 1).focus().trigger('click');
      }
    });

    // ── Sync dots after slide change ──────────────────────────
    function syncDots() {
      $carousel.find('.slick-dots li').each(function () {
        var isActive = jQuery(this).hasClass('slick-active');
        jQuery(this).find('button')
          .attr('aria-selected', isActive ? 'true' : 'false')
          .attr('tabindex', isActive ? '0' : '-1');
      });
    }

    // ── Remove redundant links ────────────────────────────────
    function removeRedundantLinks() {
      $carousel.find('.slick-slide').each(function () {
        var $slide = jQuery(this);

        $slide.find('[data-js-product-image]')
          .attr('tabindex', '-1')
          .attr('aria-hidden', 'true');

        $slide.find('.absolute-stretch')
          .attr('tabindex', '-1')
          .attr('aria-hidden', 'true');

        $slide.find('[data-js-product-images-navigation]')
          .attr('tabindex', '-1')
          .attr('aria-hidden', 'true');
      });
    }

    // ── Slide ARIA ────────────────────────────────────────────
    function initSlides() {
      var $realSlides = $carousel.find('.slick-slide:not(.slick-cloned)');
      var total       = $realSlides.length;

      $carousel.find('.slick-slide').each(function () {
        var $slide = jQuery(this);

        $slide
          .attr('role', 'group')
          .attr('aria-roledescription', 'slide');

        if ($slide.hasClass('slick-cloned')) {
          $slide.attr('aria-hidden', 'true');
          $slide.find('a, button, [tabindex]').attr('tabindex', '-1');
        } else {
          var realIdx = $realSlides.index($slide) + 1;
          $slide.attr('aria-label', 'Slide ' + realIdx + ' of ' + total);
        }
      });
    }

    // ── Live region ───────────────────────────────────────────
    if (!jQuery('#carousel-live-region').length) {
      jQuery('body').append(
        '<div id="carousel-live-region" role="status" aria-live="polite" aria-atomic="true" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;"></div>'
      );
    }

    function announceSlide() {
      var $activeSlide = $carousel.find('.slick-slide.slick-active:not(.slick-cloned)').first();
      var productName  = $activeSlide.find('[data-js-product-image] img').attr('alt') || '';
      var price        = $activeSlide.find('.price, [data-js-product-price]').first().text().trim();
      var announcement = productName;
      if (price) announcement += ', ' + price;
      jQuery('#carousel-live-region').text(announcement || 'Next slide');
    }

    // ── Pause autoplay on focus ───────────────────────────────
    $carousel.on('focusin', function () {
      try { $carousel.slick('slickPause'); } catch (e) {}
    });

    $carousel.on('focusout', function () {
      setTimeout(function () {
        if (!$carousel.find(':focus').length) {
          try { $carousel.slick('slickPlay'); } catch (e) {}
        }
      }, 100);
    });

    // ── Watch for slide changes via click ─────────────────────
    jQuery(document).off('click.carouselNav').on('click.carouselNav', '.carousel__prev-placeholder, .carousel__next-placeholder, .slick-dots button', function () {
      setTimeout(function () {
        syncDots();
        announceSlide();
        removeRedundantLinks();
      }, 350);
    });

    // ── MutationObserver for autoplay ─────────────────────────
    var $track = $carousel.find('.slick-track')[0];
    if ($track) {
      new MutationObserver(function () {
        syncDots();
        announceSlide();
        removeRedundantLinks();
      }).observe($track, {
        attributes:      true,
        attributeFilter: ['style']
      });
    }

    // ── Initial setup ─────────────────────────────────────────
    initSlides();
    initDots();
    removeRedundantLinks();
    announceSlide();
  }

  setTimeout(initCarousel, 500);

});



//===================

// ── Add visible label for email input ─────────────────────

// jQuery(document).ready(function () {

//   var $emailInput = jQuery('input[name="contact[email]"]');
//   var $form       = $emailInput.closest('form');

//   if ($emailInput.length && $form.length) {

//     // Add unique ID to input so label can reference it
//     $emailInput.attr('id', 'newsletter-email');

//     // Create visible label
//     var $label = jQuery('<label>', {
//       'for':   'newsletter-email',
//       'text':  'Email',
//       'class': 'newsletter-email-label'
//     });

//     // ✅ Insert ABOVE the form, not inside it
//     $form.before($label);

//     // Remove aria-label since we now have a visible label
//     $emailInput.removeAttr('aria-label');
//   }

// });


//==================================


// // ── Reviews Carousel Accessibility ────────────────────────
// jQuery(document).ready(function () {

//   function initReviewsCarousel() {
//     var $carousel  = jQuery('.carousel-reviews__reviews');
//     var $slick     = $carousel.find('[data-js-carousel-slick]');

//     if (!$slick.length) return;

//     // ── Wrap in landmark region ──────────────────────────────
//     $carousel.attr({
//       'role':       'region',
//       'aria-label': 'Customer reviews'
//     });

//     // ── Find prev/next arrows ────────────────────────────────
//     // Look for arrows outside the slick wrapper (sibling elements)
//     var $prevBtn = $carousel.closest('.carousel-reviews')
//                     .find('[data-js-carousel-prev], [class*="carousel__prev"]').first();
//     var $nextBtn = $carousel.closest('.carousel-reviews')
//                     .find('[data-js-carousel-next], [class*="carousel__next"]').first();

//     $prevBtn
//       .attr('tabindex', '0')
//       .attr('role', 'button')
//       .attr('aria-label', 'Previous review');

//     $nextBtn
//       .attr('tabindex', '0')
//       .attr('role', 'button')
//       .attr('aria-label', 'Next review');

//     // // ── Add Play/Pause button ────────────────────────────────
//     // if (!jQuery('#reviews-carousel-playpause').length) {
//     //   var $playPause = jQuery('<button>', {
//     //     id:            'reviews-carousel-playpause',
//     //     'aria-label':  'Pause reviews carousel',
//     //     'aria-pressed': 'false',
//     //     class:         'reviews-carousel__playpause',
//     //     html: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="16" height="16"><path class="playpause-icon" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>'
//     //   });

//     //   // Insert play/pause after the carousel region
//     //   $carousel.after($playPause);
//     // }

//     var isPlaying = true;

//     jQuery(document).on('click', '#reviews-carousel-playpause', function () {
//       var $btn = jQuery(this);
//       isPlaying = !isPlaying;

//       if (isPlaying) {
//         try { $slick.slick('slickPlay'); } catch (e) {}
//         $btn
//           .attr('aria-label', 'Pause reviews carousel')
//           .attr('aria-pressed', 'false')
//           .find('.playpause-icon')
//           // Pause icon paths
//           .attr('d', 'M6 19h4V5H6v14zm8-14v14h4V5h-4z');
//       } else {
//         try { $slick.slick('slickPause'); } catch (e) {}
//         $btn
//           .attr('aria-label', 'Play reviews carousel')
//           .attr('aria-pressed', 'true')
//           .find('.playpause-icon')
//           // Play icon path
//           .attr('d', 'M8 5v14l11-7z');
//       }
//     });

//     // ── Keyboard on prev/next ────────────────────────────────
//     jQuery(document).off('keydown.reviewsArrows')
//       .on('keydown.reviewsArrows', '[data-js-carousel-prev], [data-js-carousel-next]', function (e) {
//         if (e.key === 'Enter' || e.key === ' ') {
//           e.preventDefault();
//           jQuery(this).trigger('click');
//         }
//       });

//     // ── Keyboard on play/pause ───────────────────────────────
//     jQuery(document).on('keydown', '#reviews-carousel-playpause', function (e) {
//       if (e.key === 'Enter' || e.key === ' ') {
//         e.preventDefault();
//         jQuery(this).trigger('click');
//       }
//     });

//     // ── Init slides ──────────────────────────────────────────
//     function initSlides() {
//       var $realSlides = $slick.find('.carousel__item:not(.slick-cloned)');
//       var total       = $realSlides.length;

//       $slick.find('.carousel__item').each(function () {
//         var $slide    = jQuery(this);
//         var title     = $slide.find('.carousel-reviews__title').text().trim();
//         var stars     = $slide.find('.carousel-reviews__stars i').length;
//         var paragraph = $slide.find('.carousel-reviews__paragraph').text().trim();

//         // Hide cloned slides from AT
//         if ($slide.hasClass('slick-cloned')) {
//           $slide
//             .attr('aria-hidden', 'true')
//             .find('[tabindex]').attr('tabindex', '-1');
//           return;
//         }

//         var realIdx = $realSlides.index($slide) + 1;

//         $slide.attr({
//           'role':              'group',
//           'aria-roledescription': 'slide',
//           'aria-label':        'Review ' + realIdx + ' of ' + total + ': ' + title
//         });

//         // Make stars accessible
//         $slide.find('.carousel-reviews__stars').attr({
//           'aria-label': stars + ' out of 5 stars',
//           'role':       'img'
//         });
//         $slide.find('.carousel-reviews__stars i').attr('aria-hidden', 'true');
//       });

//       // Wrap in a list-like group
//       $slick.find('.slick-track').attr({
//         'role':       'list',
//         'aria-label': 'Review slides'
//       });
//     }

//     // ── Live region ──────────────────────────────────────────
//     if (!jQuery('#reviews-live-region').length) {
//       jQuery('body').append(
//         '<div id="reviews-live-region" role="status" aria-live="polite" aria-atomic="true" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;"></div>'
//       );
//     }

//     function announceSlide() {
//       var $active = $slick.find('.slick-current:not(.slick-cloned)');
//       var title   = $active.find('.carousel-reviews__title').text().trim();
//       var stars   = $active.find('.carousel-reviews__stars i').length;
//       var $all    = $slick.find('.carousel__item:not(.slick-cloned)');
//       var current = $all.index($active) + 1;
//       var total   = $all.length;

//       jQuery('#reviews-live-region').text(
//         'Review ' + current + ' of ' + total + ': ' + title + ', ' + stars + ' stars'
//       );
//     }

//     // ── Pause on focus, resume on blur ───────────────────────
//     $carousel.on('focusin', function () {
//       try { $slick.slick('slickPause'); } catch (e) {}
//     });

//     $carousel.on('focusout', function () {
//       setTimeout(function () {
//         if (isPlaying && !$carousel.find(':focus').length) {
//           try { $slick.slick('slickPlay'); } catch (e) {}
//         }
//       }, 100);
//     });

//     // ── Watch for slide changes ──────────────────────────────
//     var $track = $slick.find('.slick-track')[0];
//     if ($track) {
//       new MutationObserver(function () {
//         announceSlide();
//       }).observe($track, {
//         attributes:      true,
//         attributeFilter: ['style']
//       });
//     }

//     // ── Initial setup ────────────────────────────────────────
//     initSlides();
//     announceSlide();
//   }

//   setTimeout(initReviewsCarousel, 500);

// });



//==================================

jQuery(document).ready(function(){

jQuery('.slider__prev, .slider__next')
.attr({
    "role":"button",
    "tabindex":"0"
});

jQuery('.slider__prev').attr("aria-label","Previous slide");
jQuery('.slider__next').attr("aria-label","Next slide");

});

jQuery('.slider__prev, .slider__next').on('keydown', function(e){

    if(e.key === "Enter" || e.key === " "){
        e.preventDefault();
        jQuery(this).click();
    }

});

jQuery('.js-slider-tracking').attr({
    "role":"region",
    "aria-label":"Product slider",
    "aria-live":"polite"
});






//===================

// ── Collection Grid View Buttons Accessibility ────────────
function initGridViewButtons() {
  var gridLabels = {
    '1':    '1 column view',
    '2':    '2 column view',
    '3':    '3 column view',
    '4':    '4 column view',
    'list': 'List view'
  };

  var $buttons = jQuery('[data-js-collection-grid-buttons] [data-value]');

  // ✅ Set ARIA attributes on all buttons
  $buttons.each(function () {
    var $btn  = jQuery(this);
    var value = $btn.attr('data-value');
    var label = gridLabels[value] || (value + ' column view');

    $btn
      .attr('role',       'button')
      .attr('tabindex',   '0')
      .attr('aria-label', label)
      .attr('aria-pressed', 'false'); // default all to false
  });

  // ✅ Mark initial active button based on viewport data-active-* attribute
  var $initialActive = $buttons.filter(function () {
    var attrs = this.attributes;
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i].name.indexOf('data-active') === 0) {
        return true;
      }
    }
    return false;
  }).filter(':visible').first();

  if ($initialActive.length) {
    $initialActive.attr('aria-pressed', 'true');
  }

  // ── Click: update aria-pressed ────────────────────────────
  jQuery(document).on('click', '[data-js-collection-grid-buttons] [data-value]', function () {
    var $clicked = jQuery(this);

    // Reset ALL to false
    $buttons.attr('aria-pressed', 'false');

    // Set only clicked to true
    $clicked.attr('aria-pressed', 'true');

    // Announce to screen reader
    var label     = $clicked.attr('aria-label');
    var $announce = jQuery('#grid-view-announcement');
    if ($announce.length) {
      $announce.text('');
      setTimeout(function () {
        $announce.text(label + ' selected');
      }, 50);
    }
  });

  // ── Keyboard: Enter / Space to activate ──────────────────
  jQuery(document).on('keydown', '[data-js-collection-grid-buttons] [data-value]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      jQuery(this).trigger('click');
    }

    // ── Arrow keys to navigate between visible buttons ────
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      var $visible = $buttons.filter(':visible');
      var index    = $visible.index(this);

      if (e.key === 'ArrowRight') {
        $visible.eq((index + 1) % $visible.length).focus();
      } else {
        $visible.eq((index - 1 + $visible.length) % $visible.length).focus();
      }
    }
  });
}

// ── Init ──────────────────────────────────────────────────
initGridViewButtons();


//================

// ── Product Collection Image Navigation Accessibility ─────
function initProductImagesNavigation() {

  // ✅ Set aria-label once title is available
  function setNavLabels() {
    jQuery('[data-js-product-images-navigation="prev"]').each(function () {
      var $btn      = jQuery(this);
      var $container = $btn.closest('product-item');
      if (!$container.length) $container = $btn.closest('div.product-collection__wrapper');

      var title = $container.find('.b4b-title').first().text().trim();
      if (!title) return; // skip if title not yet rendered

      $btn
        .attr('role',       'button')
        .attr('tabindex',   '0')
        .attr('aria-label', title + ' - Previous product image');
    });

    jQuery('[data-js-product-images-navigation="next"]').each(function () {
      var $btn       = jQuery(this);
      var $container = $btn.closest('product-item');
      if (!$container.length) $container = $btn.closest('div.product-collection__wrapper');

      var title = $container.find('.b4b-title').first().text().trim();
      if (!title) return; // skip if title not yet rendered

      $btn
        .attr('role',       'button')
        .attr('tabindex',   '0')
        .attr('aria-label', title + ' - Next product image');
    });
  }

  // ✅ Run immediately in case content is already rendered
  setNavLabels();

  // ✅ Watch for dynamically rendered product titles
  var observer = new MutationObserver(function () {
    setNavLabels();
  });

  observer.observe(document.body, {
    childList: true,
    subtree:   true
  });

  // ✅ Stop observing after 5s — titles should be loaded by then
  setTimeout(function () {
    observer.disconnect();
  }, 5000);

  // ✅ Keyboard: Enter / Space to activate
  jQuery(document).on('keydown', '[data-js-product-images-navigation]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      jQuery(this).trigger('click');
    }
  });

  // ✅ Announce via live region on click
  jQuery(document).on('click', '[data-js-product-images-navigation]', function () {
    var label     = jQuery(this).attr('aria-label') || '';
    var $announce = jQuery('#product-nav-announcement');
    if ($announce.length) {
      $announce.text('');
      setTimeout(function () {
        $announce.text(label);
      }, 50);
    }
  });
}

// ── Init ──────────────────────────────────────────────────
initProductImagesNavigation();